
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"179","height":"125","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M36.103 18.094c0-9.803 7.947-17.75 17.75-17.75 9.804 0 17.75 7.947 17.75 17.75s-7.946 17.75-17.75 17.75c-9.803 0-17.75-7.947-17.75-17.75zm140.226 86.354l-53.25-71a6.747 6.747 0 00-10.65 0l-35.5 45.884a4.437 4.437 0 01-6.923 0L50.57 55.724a6.656 6.656 0 00-10.384 0L2.467 104.448a8.875 8.875 0 00-1.863 5.413v8.077a6.745 6.745 0 006.656 6.656h164.187a6.746 6.746 0 006.657-6.656v-8.165a8.874 8.874 0 00-1.775-5.325z","fill":"#000"}})])
          )
        }
      }
    